const ABORT_OR_TIMEOUT_NAMES = new Set([
  "AbortError",
  "TimeoutError",
  "RequestTimeoutError"
]);

/** Request cancelled by the client (navigation, tab sleep) or hit its timeout, also when wrapped as an Error cause; not actionable in Sentry. */
export const isAbortOrTimeoutError = (error: unknown): boolean => {
  const seen = new Set<unknown>();
  let current = error;
  while (current instanceof Object && !seen.has(current)) {
    if (ABORT_OR_TIMEOUT_NAMES.has((current as { name?: string }).name ?? "")) {
      return true;
    }
    seen.add(current);
    current = (current as { cause?: unknown }).cause;
  }
  return false;
};
